<template>
  <layout>
    <template slot="authentication-content">
      <b-container fluid>
        <b-row align-h="center">
          <b-col lg="6">
            <b-card>
              <change-password to-login :to="{ name: 'login', params: { displayModal: firstLogin }}" :token="token" />
              <router-link :to="{ name: 'login' }">
                {{ $t('oauth.login.title') }}
              </router-link>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </layout>
</template>

<script>
  import Layout from '@/views/Authentication/layout';
  import ChangePassword from '@/components/change-password';

  export default {
    name: 'PasswordResetView',
    components: {
      Layout,
      ChangePassword,
    },
    props: {
      token: {
        type: String,
        default: null,
      },
      firstLogin: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>
